import { useAuthContext } from "../../../auth/hooks"
import { Avatar, AvatarFallback, AvatarImage } from "../../../components/ui/avatar"
import { useRouter } from "../../../hooks/use-router"

const fname = localStorage.getItem("firstName")?.toUpperCase();
const role = localStorage.getItem('roleName')

export const ProfileUserDetail = () => {

    const { user } = useAuthContext()
    const router = useRouter()

    const handleViewProfile=()=>{
        if(role!="Admin")
            router.push("/profile")
      }

    return(
        <div className="p-4">
        <div>
          <div className="flex items-center">
            <Avatar className="rounded-xl cursor-pointer" onClick={handleViewProfile}>
              <AvatarImage src="https://github.com/shadcn.png" />
              <AvatarFallback >CN</AvatarFallback>
            </Avatar>
            <div className="ml-3">
              <h4
                className="text-sm font-medium"
              >
                {user?.fullName?.toUpperCase() || fname}
              </h4>
              <p className="text-xs opacity-60">{user?.designation || role || ''}</p>
            </div>
          </div>
        </div>
      </div>
    )
}